
enum Command {
	ADD_CLIENT = 5,
	CONNECTION_ID_LOGIN = 7,
	CREATE_ACCOUNT = 35,
	PW_LOGIN = 36,
}

enum RoomSubCommand {
	SC_DRAG_PARAMS = 1, // каждому живому сопернику отправляем данные обоих машин и другие необходимые параметры заезда; в случае заезда на чужой ноде отправляем эту субкоманду принудительно
	SC_DRAG_READY = 2, // соперник отправляет событие готовности к приёму параметров заезда
	SC_DRAG_KEY_DOWN = 3,  // нажата клавиша
	SC_DRAG_KEY_UP = 4, // отжата клавиша
	SC_DRAG_DELETE = 5,  // команда для убегания из комнаты заезда (в TL была отладочной)
	SC_COUNTDOWN = 6,  // обратный отчёт перед стартом, игрокам приходят оставшиеся секунды
	SC_STATE1 = 7,  // отправка игрокам газа и передачи, для режима газовки во время отсчёта
	SC_FINISH = 8,  // индекс победителя в комнате, его финишное время и скорость
	SC_RACE_DATA_PERSONAL = 9, // данные заезда, персональные для игрока: текущая передача, ускорение
	SC_RACE_DATA_COMMON = 10,  // данные заезда, отправляемые обоим игрокам: расстояние, обороты, скорость 
	SC_CONTROL_ERROR = 11, // ошибка нажатия кнопок (попытка переключить передачу при нажатом газе)
	SC_DELETE_ROOM = 12, // когда перед заездом обнаружилось, что один из клиентов соперников отвалился, отправляем команду уничтожения комнаты
	SC_IGNITION_STATE = 13, // событие состояния зажигания; приняв событие с параметром state=0, клиент должен выключить мотор, если тот был включен, и отобразить интерфейс замка зажигания
													// - если пришло state=1, а мотор был выключен, то клиент должен его включить (звук, тряска двигателя/машины)
	SC_IGNITION_KEY = 14, // клиент игрока отправляет код ключа зажигания (1, 2 или 3), сервер проверяет и запоминает его правильность/неправильность
	
}

enum Common {
//const LOCAL_STORAGE_AUTH_VAR_NAME = "gorDebugDemoData";
	LOCAL_STORAGE_AUTH_VAR_NAME = "gorData",
	AUTH_SALT = "k28oQ1",
	
}

export default {Command, RoomSubCommand, Common};

